package com.nonopn.skydome.common.app.utils

import kotlin.math.absoluteValue
import kotlin.math.pow
import kotlin.math.round

/**
 * KMP-safe number formatting utilities.
 *
 * korlibs.io.lang.format does not resolve float format specifiers (%.Xf)
 * at runtime on Android — it returns the raw format string instead.
 * These functions replace all "%.Xf".format(value) usages.
 */

/**
 * Format a Double with [decimals] decimal places. KMP-safe.
 * Example: 4.6.fmt(2) → "4.60"
 */
fun Double.fmt(decimals: Int): String {
    if (this.isNaN() || this.isInfinite()) return "—"
    // Rounded like the other precisions (45.96 -> "46"), never truncated
    if (decimals <= 0) return round(this).toLong().toString()
    val factor = 10.0.pow(decimals)
    val rounded = round(this.absoluteValue * factor) / factor
    val s = rounded.toString()
    val dot = s.indexOf('.')
    val intPart = if (dot >= 0) s.substring(0, dot) else s
    val fracPart = if (dot >= 0) s.substring(dot + 1) else ""
    val sign = if (this < 0) "-" else ""
    return "$sign$intPart.${fracPart.take(decimals).padEnd(decimals, '0')}"
}

/** Zero-pad an Int to 2 digits. KMP-safe replacement for "%02d".format(). */
fun Int.pad2(): String = this.toString().padStart(2, '0')
